import { render } from "./B2bPageUsuario.vue?vue&type=template&id=b27ac91e&scoped=true&lang=pug"
import script from "./B2bPageUsuario.vue?vue&type=script&lang=js"
export * from "./B2bPageUsuario.vue?vue&type=script&lang=js"

import "./B2bPageUsuario.vue?vue&type=style&index=0&id=b27ac91e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27ac91e"]])

export default __exports__